import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Game {
  constructor() {}
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents.bind(this));

    Global.totalGoalsSaved = 0;
    this.hattrickCheck = 0;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'defend':
        this.updateGoal();
        // this.showMiss();
        break;
      case 'goal':
        this.showGameOver();
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Game') return false;

    Global.totalGoalsSaved = 0;
    document.querySelector('#game_header .score').innerHTML = `00`;

    // document.querySelector("#game_header").classList.add("active")
    document.querySelector('.defend_popup').classList.add('active');
  }

  updateGoal() {
    Global.totalGoalsSaved++;
    this.hattrickCheck++;

    document.querySelectorAll('.defend_popup img').forEach((img) => {
      img.classList.remove('active');
    });
    const calloutIndex = Math.floor(Math.random() * 4 + 1);
    document
      .querySelector(`.defend_popup img:nth-child(${calloutIndex})`)
      .classList.add('active');
    document.querySelector('.defend_popup').classList.add('active2');
    document.querySelector('#game_header .score').innerHTML = `${
      Global.totalGoalsSaved < 10 ? '0' : ''
    }${Global.totalGoalsSaved}`;

    setTimeout(() => {
      document.querySelector('.defend_popup').classList.remove('active2');
    }, 1500);
  }
  showGameOver() {
    document.querySelector('.defend_popup').classList.add('active2');
    document.querySelectorAll('.defend_popup img').forEach((img) => {
      img.classList.remove('active');
    });
    document
      .querySelector(`.defend_popup img:nth-child(6)`)
      .classList.add('active');

    setTimeout(() => {
      document.querySelector('.defend_popup').classList.remove('active2');
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'game_over',
          data: {},
        },
      });
    }, 3000);
  }

  updateVolume(v) {
    v.preventDefault();
    v.stopPropagation();
    v.stopImmediatePropagation();

    Global.soundEnabled = !Global.soundEnabled;
    if (Global.soundEnabled) {
      document
        .querySelector('#game_header #volumeBtn')
        .classList.remove('active');
      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'play_sound',
          data: {
            sndKey: 'crowd',
          },
        },
      });
    } else {
      document.querySelector('#game_header #volumeBtn').classList.add('active');
      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'stop_sound',
          data: {
            sndKey: 'crowd',
          },
        },
      });
    }
  }
}
